import React from 'react';

import { makeStyles } from 'tss-react/mui';
import useLayoutStore from 'storages/layout';
import LAYOUT_SIZES from 'constants/styles/LAYOUT_SIZES';

const useStyles = makeStyles()((theme, { footerFree, headerFree, justify }) => ({
  container: {
    transition: `400ms`,
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: justify,
    alignItems: 'center',
    paddingTop: !headerFree && LAYOUT_SIZES.HEADER.md,
    paddingBottom: !footerFree && LAYOUT_SIZES.FOOTER.md,
    [theme.breakpoints.down('md')]: {
      paddingTop: !headerFree && LAYOUT_SIZES.HEADER.sm,
      paddingBottom: !footerFree && LAYOUT_SIZES.FOOTER.sm,
    },
  },
}));

function FullScreen({ children, justify = 'center', headerFree = false, footerFree = false, className = null }) {
  const { isHeaderVisible } = useLayoutStore();
  // TODO: change layout to MUI way
  const {
    classes: { container },
    cx,
  } = useStyles({
    headerFree: headerFree || !isHeaderVisible,
    justify,
    footerFree,
  });
  return <div className={cx(container, className)}>{children}</div>;
}

export default FullScreen;
